var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pov-select',{attrs:{"filter":_vm.pnvSelectFilter,"text":_vm.PovNr,"mutation-name":_vm.mutationsMappers.mutationName,"data-cy":"povSelect","action-name":_vm.actionsMapper.actionName},on:{"update:text":function($event){_vm.PovNr=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }